export default __webpack_public_path__ + "static/media/456.bbdd8d6c.png";